import { screenMdMin } from '@spotify-internal/encore-foundation';
import { TagInputItem } from "../TagInputItem/index.mjs";
import { ButtonPrimary } from "../../../core/components/ButtonPrimary/index.mjs";
import { FormGroup } from "../../../core/components/FormGroup/index.mjs";
import styled from "../../../core/styled-components.mjs";
import { cssColorVar, cssSpacing } from "../../../core/styles/index.mjs";
export var Wrapper = styled.div.withConfig({
  displayName: "indexstyled__Wrapper",
  componentId: "sc-htq6v5-0"
})(["display:flex;justify-content:space-between;align-items:center;"]);
export var PillWrapper = styled.div.withConfig({
  displayName: "indexstyled__PillWrapper",
  componentId: "sc-htq6v5-1"
})(["display:flex;flex-wrap:wrap;"]);
export var SearchPill = styled(TagInputItem).withConfig({
  displayName: "indexstyled__SearchPill",
  componentId: "sc-htq6v5-2"
})(["margin-right:", ";margin-bottom:", ";"], cssSpacing('tighter', '12px'), cssSpacing('tighter', '12px'));
export var InputContainer = styled(FormGroup).withConfig({
  displayName: "indexstyled__InputContainer",
  componentId: "sc-htq6v5-3"
})(["display:flex;align-items:flex-start;"]);
export var SearchButton = styled(ButtonPrimary).withConfig({
  displayName: "indexstyled__SearchButton",
  componentId: "sc-htq6v5-4"
})(["align-self:flex-start;width:max-content;cursor:pointer;"]);
export var Container = styled.div.withConfig({
  displayName: "indexstyled__Container",
  componentId: "sc-htq6v5-5"
})(["padding:", " ", " 60px;background-color:var(", ");color:var(", ");display:flex;justify-content:center;@media (min-width:", "){padding:", " ", " 60px;}"], cssSpacing('looser-5', '48px'), cssSpacing('looser-3', '32px'), cssColorVar('backgroundHighlight'), cssColorVar('textBase'), screenMdMin, cssSpacing('looser-3', '48px'), cssSpacing('looser-5', '104px'));
export var Content = styled.div.withConfig({
  displayName: "indexstyled__Content",
  componentId: "sc-htq6v5-6"
})(["width:100%;"]);
export var TitleWrapper = styled(Wrapper).withConfig({
  displayName: "indexstyled__TitleWrapper",
  componentId: "sc-htq6v5-7"
})(["margin:40px 0;"]);
export var ResultCountWrapper = styled(Wrapper).withConfig({
  displayName: "indexstyled__ResultCountWrapper",
  componentId: "sc-htq6v5-8"
})(["margin-top:40px;"]);